import axios from "axios";
export const loginAPI = (data) => {
  return axios.post(`https://usmapi.sulonya.com/api/Auth/Login`, { ...data });
};

export const registerAPI = (data) => {
  return axios.post(`https://usmapi.sulonya.com/api/Auth/Register`, {
    ...data,
  });
};
export const saveUserKey = (token) => {
  let config = {
    method: "post",
    url: "https://blockchainapi.sulonya.com/api/UserKey/SaveUserKey",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};
export const uploadFile = (data) => {
  console.log("post", data);
  return axios.post(`https://sulonyafiles.sulonya.com/files/upload`, data);
};
export const saveData = (data) => {
  let token = localStorage.getItem("userToken");
  let config = {
    method: "post",
    url: "https://blockchainapi.sulonya.com/api/Block/SaveData",
    data: { ...data },
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  return axios(config);
};